<template>
     <div class="modal-card">

        <b-loading :is-full-page=true v-model="isLoadingFullPage" ></b-loading>
 <!-- class="mb-5 mr-5"  -->
        <header class="modal-card-head"> 
             <b-button icon-left="close" 
                type="is-text"
                
                size="is-small"
                @click="close"> 
             </b-button>

            {{resWithOTP.msg}}  
            
            <span  class="has-text-danger  ml-3">{{resWithOTP.email}}</span> 



        </header>
        <section class="modal-card-body">
            
         
  

            <b-field label="Counter">
              <span class="has-text-danger  is-size-4">  {{count}}</span>
            </b-field>

            <b-field label="Your Ref Code">
               {{resWithOTP.ref_code}}
            </b-field>


            <b-field label="Your OTP"
            :type="hasErrFailtoLogin ?  'is-danger' : '' "
            :message="hasErrFailtoLogin  ? 'This otp is invalid' : '' "
            >
                <OTPInput  @changeOTP = "change_OTPInput" 
                           @submitOTP = "submitOTP" 
                           />
            </b-field>

             
            <b-field> 
                
                    <!-- <b-button label="Send OTP To Login" 
                              type="is-primary" 
                              :disabled="!timerRunning" 
                              @click="doLogin"/> -->


                            <div class="columns">
                                    <div class="column">
                                        <b-button label="Send OTP To Login" 
                                                type="is-primary" 
                                                :disabled="!timerRunning || !otp.every(item => item !== '')" 
                                                @click="doLogin"/>
                                    </div>
                                 
                                    <div class="column is-narrow">
                                        <b-button label="Close" 
                                                type="is-danger" 
                                                :disabled="timerRunning" 
                                                @click="close"/>  
                            </div>
    </div>


                           
                
            </b-field>

            

        <b-notification
            v-if="hasErrFailtoLogin"
            type="is-danger"
            has-icon
            aria-close-label="Close notification"
            role="alert">
            {{errMessage}}
        </b-notification>   
        
        
        <!-- <OTPInput   />  -->

        </section>
     

          

   

    </div>
</template>


<script>
import axios from "axios"
import {   getBaseURLforBackEnd  , getConfigAxios , } from '@/utils.js'
    
 
import OTPInput from './OTPInput.vue'


export default {
    name : "DlgGetOTP",
    components:{
        OTPInput ,
    },
    
    props:{
        resWithOTP : Object,

        usrname : String,
        passwd : String,
        fingerPrint : String,
        clientIP : String,

    },
    mounted(){
        // this.$refs.inputOTP.focus();
        this.startTimer()
    },
    created() {
            const unregisterRouterGuard = this.$router.beforeEach((to, from, next) => {
                this.close()
                next(false)
            })
            this.$once('hook:destroyed', () => {
                unregisterRouterGuard()
            })
    },
    methods:{
        submitOTP(payloadOTP){



            console.log(payloadOTP)
            if(this.timerRunning && payloadOTP.length==6){
                // console.log("ok to check") 
                this.doLogin(payloadOTP)
            }else{
            //   console.log("not ok")   
              this.hasErrFailtoLogin = true
              this.errMessage ='Login fail'          
            }
            
            
        },
        change_OTPInput(payload){
             this.otp = payload

             this.hasErrFailtoLogin = false
             this.errMessage =''   
            //  return payload
        },  

       async doLogin(_otp){
              // closeDlgGetOTPWithLoginSuccess
              const dat =   {
                    "username" : this.usrname,
                    "password" : this.passwd,
                    "fp": this.fingerPrint,
                    "ip": this.clientIP,
                    "kick": "Y",
                    "otp" :  _otp ,
                    "ref_code" : this.resWithOTP.ref_code
                }
 
               
                // const vm = this
                // console.log(JSON.stringify(dat))
                this.isLoginIncorrect = false
                this.isLoadingFullPage = true
              
                await   axios.post(`${getBaseURLforBackEnd()}/api/loginwithotp`,dat,getConfigAxios())
                    .then((res) => {
                           this.isLoadingFullPage = false
                           this.$emit('closeWithLoginSuccess',res.data)

                    })
                    .catch((err)=>{
                        this.hasErrFailtoLogin = true
                        this.errMessage = err.response.data.message
                        this.isLoadingFullPage = false
                    })
        },
        close(){
            clearInterval(this.timer); 
            this.$emit('close')
        },


        startTimer() {
            if (!this.timerRunning) {
                this.timer = setInterval(() => {
                if (this.count > 0) {
                    this.count--;
                } else {
                    this.stopTimer();
                }
                }, 1000);
                this.timerRunning = true;
            }
        },
        stopTimer() {
            clearInterval(this.timer);
            this.timerRunning = false;
        }




    },
    data(){
        return {
            isLoadingFullPage : false,
            otp :  ["", "", "", "", "", ""],



            count: 60, // Initial countdown value
            timerRunning: false, // Flag to check if timer is running
            timer: null ,// Timer reference

            hasErrFailtoLogin : false,
            errMessage : "",



        }
    }
}
</script>